import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const RspPaymentMob = () => {
  return <CommonProcess />;
};

export default RspPaymentMob;
